import { render } from "./ProductTranslations.vue?vue&type=template&id=2bf1eec6&scoped=true"
import script from "./ProductTranslations.vue?vue&type=script&lang=js"
export * from "./ProductTranslations.vue?vue&type=script&lang=js"

import "./ProductTranslations.vue?vue&type=style&index=0&id=2bf1eec6&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf1eec6"]])

export default __exports__